export default "__VITE_ASSET__vZN5kqFm__"